// Scoped placeholder/label sync for corporate form
(function() {
  function enhanceCorporateForm() {
    var root = document.getElementById('corporate_page_custom_form');
    if (!root) return;

    var isMobile = window.matchMedia && window.matchMedia('(max-width: 768px)').matches;

    function setSelectOptions(selectEl, values) {
      if (!selectEl) return;
      // Preserve first placeholder option if present/disabled with empty value
      var placeholder = null;
      if (selectEl.options && selectEl.options.length) {
        var first = selectEl.options[0];
        if (first && first.disabled && first.value === '') {
          placeholder = { text: first.textContent, value: '' };
        }
      }
      // Clear all options
      while (selectEl.firstChild) selectEl.removeChild(selectEl.firstChild);
      // Re-add placeholder
      if (placeholder) {
        var ph = document.createElement('option');
        ph.value = '';
        ph.disabled = true;
        ph.selected = true;
        ph.textContent = placeholder.text;
        selectEl.appendChild(ph);
      }
      // Add provided values
      values.forEach(function(text) {
        var opt = document.createElement('option');
        opt.value = text;
        opt.textContent = text;
        selectEl.appendChild(opt);
      });
    }

    function updateSelectPlaceholderClass(selectEl){
      if (!selectEl) return;
      var isPlaceholder = !selectEl.value || selectEl.value === '';
      if (isPlaceholder) {
        selectEl.classList.add('is-placeholder');
      } else {
        selectEl.classList.remove('is-placeholder');
      }
    }

    var labels = root.querySelectorAll('label[for]');
    labels.forEach(function(label) {
      var id = label.getAttribute('for');
      if (!id) return;
      var field = root.querySelector('#' + CSS.escape(id));
      if (!field) return;

      var labelText = (label.textContent || '').trim();
      if (!labelText) return;

      // Inputs and textareas: use placeholder
      if (field.tagName === 'INPUT' || field.tagName === 'TEXTAREA') {
        if (!field.getAttribute('placeholder')) {
          field.setAttribute('placeholder', labelText);
        }
        // keep accessibility
        field.setAttribute('aria-label', labelText);
        // visually hide the label but keep it in DOM for a11y
        label.classList.add('visually-hidden');
      }

      // Selects: ensure a disabled placeholder option exists
      if (field.tagName === 'SELECT') {
        var hasPlaceholder = false;
        if (field.options && field.options.length) {
          var first = field.options[0];
          hasPlaceholder = first.disabled && first.value === '';
        }
        if (!hasPlaceholder) {
          var opt = document.createElement('option');
          opt.value = '';
          opt.disabled = true;
          opt.selected = true;
          opt.textContent = labelText;
          field.insertBefore(opt, field.firstChild);
        }
        field.setAttribute('aria-label', labelText);
        label.classList.add('visually-hidden');

        // Normalize option lists by label
        var labelLower = labelText.toLowerCase();
        if (labelLower.includes('gifting occasion')) {
          setSelectOptions(field, [
            'New Joinee Gifts',
            'Work Anniversary Gifts',
            'Company Annual Event',
            'Employee Birthday Gifts',
            'Diwali Gifts',
            'Client Gifts',
            'Farewell Gifts',
            'Merchandise / Swag Items',
            'Trophy / Momento'
          ]);
        } else if (labelLower.includes('quantity')) {
          setSelectOptions(field, [
            '0-10',
            '10-50',
            '50-100',
            '100-300',
            '300-500',
            '501 and above'
          ]);
        }

        // Apply placeholder color state initially and on change
        updateSelectPlaceholderClass(field);
        field.addEventListener('change', function(){ updateSelectPlaceholderClass(field); });

        // Mobile-native dropdown positioning fix: disable ancestor transforms while open
        if (!field._corpFixBound) {
          field.addEventListener('focus', function() {
            if (!isMobile) return;
            document.documentElement.classList.add('corp-select-open');
            try { field.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {}
          }, true);
          field.addEventListener('blur', function() {
            if (!isMobile) return;
            // Allow native picker to close, then restore
            setTimeout(function(){
              document.documentElement.classList.remove('corp-select-open');
            }, 150);
          }, true);
          field.addEventListener('change', function(){
            if (!isMobile) return;
            document.documentElement.classList.remove('corp-select-open');
          });
          field._corpFixBound = true;
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceCorporateForm);
  } else {
    enhanceCorporateForm();
  }
})();
